module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/v2.2.1-rc.8-231.vue");


//////////////////
// WEBPACK FOOTER
// ./zh-CN/changelog/v2.2.1-rc.8.md
// module id = 665
// module chunks = 323